import { render, staticRenderFns } from "./EditarDiagnostico.vue?vue&type=template&id=72b28c73&scoped=true"
import script from "./EditarDiagnostico.vue?vue&type=script&lang=js"
export * from "./EditarDiagnostico.vue?vue&type=script&lang=js"
import style0 from "./EditarDiagnostico.vue?vue&type=style&index=0&id=72b28c73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b28c73",
  null
  
)

export default component.exports